import { render, staticRenderFns } from "./Footern.vue?vue&type=template&id=154b6bbe&scoped=true"
import script from "./Footern.vue?vue&type=script&lang=js"
export * from "./Footern.vue?vue&type=script&lang=js"
import style0 from "./Footern.vue?vue&type=style&index=0&id=154b6bbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154b6bbe",
  null
  
)

export default component.exports